$(document).ready(function () {
  // __________ Header
  $(".menu-drawer__menu-toggle").click(function (e) {
    e.preventDefault();
    $(this).toggleClass("open-submenu");
    $(this).next(".menu-drawer__submenu").slideToggle();
  });
  // __________ Header

  // __________ Image Banner section
  // if ($(".main-banner-slider").length > 0) {
  //   if ($(".main-banner-slider-row .swiper-slide").length > 1) {
  //     var swiper_image_banner = new Swiper(".main-banner-slider-row", {
  //       spaceBetween: 20,
  //       loop: true,
  //       autoplay: true,
  //       speed: 4000,
  //       pagination: {
  //         el: ".main-banner-slider-row .swiper-pagination",
  //         clickable: true,
  //       },
  //     });
  //   }
  // }

  if ($(".main-banner-slider").length > 0) {
  if ($(".main-banner-slider-row .swiper-slide").length > 1) {
    var swiper_image_banner = new Swiper(".main-banner-slider-row", {
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      speed: 200,
      allowTouchMove: false, // ✅ Disable mouse/touch swipe
      pagination: {
        el: ".main-banner-slider-row .swiper-pagination",
        clickable: false, // ✅ Disable click on pagination bullets
      },
    });
  }
}

  // __________ Image Banner section

  // __________ Customer Review
  if ($(".customer_review .customer_review-row").length) {
    var customer_review = new Swiper(".customer_review .customer_review-row", {
      slidesPerView: "auto",
      spaceBetween: 15,
      pagination: {
        el: ".customer_review-row .swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        1401: {
          spaceBetween: 30,
        },
        750: {
          spaceBetween: 20,
        },
      },
    });
  }
  // __________ Customer Review

  // __________ product video showcase
  if ($(".product-video-showcase").length > 0) {
    $(window).on("load", function () {
      $("#product-video-showcase-slider .product-video-showcase-block").each(
        function () {
          let video_url = $(this).find(".video-block").data("video");
          let video_poster = $(this).find(".video-block").data("video-poster");
          $(this)
            .find(".video-block")
            .html(
              `<video playsinline="true" autoplay="autoplay" muted="muted" loop="loop" preload="auto" poster="${video_poster}"><source src="${video_url}" type="video/mp4"><img src="${video_poster}"></video>`
            );
          // let producturl = `${$(this).data('product')}?view=video-showcase-model`;
          // fetch(producturl)
          // .then(responseText => responseText.text())
          // .then((responseText)=>{
          //   const html = new DOMParser().parseFromString(responseText, 'text/html');
          //   $('#product-video-showcase-model-slider .product-video-showcase-model-slider-data').append($(html).find('.product-video-showcase-model-block'));
          // });
        }
      );

      var product_video_showcase = new Swiper(
        "#product-video-showcase-slider",
        {
          slidesPerView: "auto",
          spaceBetween: 10,
          navigation: {
            nextEl: "#product-video-showcase-slider .swiper-button-next",
            prevEl: "#product-video-showcase-slider .swiper-button-prev",
          },
          breakpoints: {
            750: {
              spaceBetween: 20,
            },
          },
        }
      );

      var product_video_showcase_model = new Swiper(
        "#product-video-showcase-model-slider",
        {
          effect: "coverflow",
          grabCursor: false,
          centeredSlides: true,
          slidesPerView: 3,
          spaceBetween: 50,
          coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 50,
            modifier: 0,
            slideShadows: true,
          },
          on: {
            slideChange: function () {
              var currentSlide = this.slides[this.activeIndex];
              $(currentSlide)
                .siblings()
                .each(function () {
                  $(this).find("video")[0].pause();
                });

              $(currentSlide).find("video")[0].play();
            },
          },
        }
      );

      $("#product-video-showcase-slider .product-video-showcase-block").on(
        "click",
        function () {
          var clickedIndex = $(this).data("index");
          $("#product-video-showcase-model").fadeIn();
          product_video_showcase_model.slideTo(clickedIndex - 1, 0);
        }
      );
    });

    $("#product-video-showcase-model-close").on("click", function (e) {
      e.preventDefault();
      $("#product-video-showcase-model").fadeOut();
    });

    $(document).on(
      "change",
      ".product-video-showcase-model-block .show-case-read-more-btn",
      function () {
        e.preventDefault();
        $(this).parents(".description-block").toggleClass("active");
      }
    );

    $(document).on(
      "change",
      '#product-video-showcase-model .show-case-variant-opt input[type="radio"]',
      function () {
        var block = $(this).parents(".product-showcase-info");
        var url = $(this).parents(".product-showcase-info").data("url");
        var val = $(block)
          .find('.show-case-variants input[type="radio"]:checked')
          .map(function () {
            return $(this).data("option-value-id");
          })
          .get();
        var producturl = `${url}?option_values=${val.join(
          ","
        )}&view=video-showcase-model`;
        fetch(producturl)
          .then((responseText) => responseText.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            $(block)
              .find(".show-case-variants")
              .html($(html).find(".show-case-variants").html());
            $(block)
              .find(".product-showcase-price")
              .html($(html).find(".product-showcase-price").html());
            $(block)
              .find("product-form .product-variant-id")
              .val($(html).find("product-form .product-variant-id").val());
            console.log($(html).find("product-form .product-showcase_submit"));
            $(block)
              .find("product-form .product-showcase_submit")
              .replaceWith(
                $(html).find("product-form .product-showcase_submit")
              );
          });
      }
    );
  }
  // __________ product video showcase

  // if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
  //     const videos = document.querySelectorAll('video');
  //     videos.forEach(video => {
  //         video.setAttribute('playsinline', '');
  //     });
  // }

  // __________ Collection list Slider
  // if ($(".collection-list-slider-row").length > 0) {
  //   $(".collection-list-slider-row").each(function (index, section) {
  //     var collection_list_slider = new Swiper(this, {
  //       slidesPerView: 2,
  //       spaceBetween: 10,
  //       navigation: {
  //         nextEl: $(this)
  //           .parents(".collection-list-slider-row-wrap")
  //           .find(".swiper-button-next")[0],
  //         prevEl: $(this)
  //           .parents(".collection-list-slider-row-wrap")
  //           .find(".swiper-button-prev")[0],
  //       },
  //       breakpoints: {
  //         1200: {
  //           slidesPerView: "6",
  //           spaceBetween: 30,
  //         },
  //         750: {
  //           slidesPerView: "4",
  //           spaceBetween: 20,
  //         },
  //         575: {
  //           slidesPerView: "3",
  //           spaceBetween: 20,
  //         },
  //       },
  //     });
  //   });
  // }

  if (window.innerWidth > 767 && $(".collection-list-slider-row").length > 0) {
  $(".collection-list-slider-row").each(function (index, section) {
    var collection_list_slider = new Swiper(this, {
      slidesPerView: 2,
      spaceBetween: 10,
      navigation: {
        nextEl: $(this)
          .parents(".collection-list-slider-row-wrap")
          .find(".swiper-button-next")[0],
        prevEl: $(this)
          .parents(".collection-list-slider-row-wrap")
          .find(".swiper-button-prev")[0],
      },
      breakpoints: {
        1200: {
          slidesPerView: 6,
          spaceBetween: 30,
        },
        750: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        575: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
    });
  });
}


  // __________ Collection list Slider

  // __________ Trending Products
  if ($(".trending-products").length > 0) {
    $(".trending-products .trending-products-blocks").each(function (
      index,
      section
    ) {
      var trending_products = new Swiper(this, {
        slidesPerView: 1,
        spaceBetween: 12,
        effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      speed: 200,
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: $(this)
            .parents(".trending-products-blocks-wrap")
            .find(".swiper-button-next")[0],
          prevEl: $(this)
            .parents(".trending-products-blocks-wrap")
            .find(".swiper-button-prev")[0],
        },
        pagination: {
          el: $(this)
            .parents(".trending-products-blocks-wrap")
            .find(".swiper-pagination")[0],
          clickable: true,
        },
      });
    });
  }
  // __________ Trending Products

  // __________ Story Cards
  if ($("#story-cards").length > 0) {
    $(window).on("load", function () {
      $("#story-cards .story-card-media").each(function () {
        var media_type = $(this).data("type");
        var media_url = $(this).data("url");
        // var video_url = $(this).find('.video-block').data('video');
        // var video_poster = $(this).find('.video-block').data('video-poster');
        if (media_type == "image") {
          $(this).html(`<img src="${media_url}" width="100" height="100">`);
        } else {
          $(this).html(
            `<video playsinline="true" autoplay="autoplay" muted="muted" loop="loop" preload="auto"><source src="${media_url}" type="video/mp4"></video>`
          );
        }
      });
    });

    var story_cards = new Swiper("#story-cards .story-cards-slider", {
      slidesPerView: "auto",
      centeredSlides: false,
      centerInsufficientSlides: true,
      spaceBetween: 10,
      breakpoints: {
        750: {
          spaceBetween: 20,
        },
      },
    });
  }
  // __________ Story Cards

  // __________  Faq Block
  if ($("[data-faq-block]").length > 0) {
    $(document).on("click", "[data-faq-block] [data-faq-toggle]", function (e) {
      e.preventDefault();
      $(this)
        .next("[data-faq-content]")
        .slideToggle()
        .parents("[data-faq-block]")
        .toggleClass("active");
      $(this)
        .parents(".accordion")
        .siblings(".accordion")
        .find("[data-faq-block]")
        .removeClass("active")
        .find("[data-faq-content]")
        .slideUp();
    });
  }

  // __________  Faq Block

  // __________  Product main Gallary
  // Initialize Swiper instances
  if ($(".product_main_media_wrap").length > 0) {
    // Initialize thumbnail swiper
    var product_main_thumb = new Swiper("#product_main_thumbnail", {
      slidesPerView: "auto",
      spaceBetween: 5,
      direction: "vertical",
      watchSlidesProgress: true,
      breakpoints: {
        990: {
          spaceBetween: 10,
        },
      },
    });

    // Initialize main image swiper
    var product_main_image = new Swiper("#product_main_media_list", {
      slidesPerView: 1,
      spaceBetween: 5,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: "#product_main_media_list .swiper-button-next",
        prevEl: "#product_main_media_list .swiper-button-prev",
      },
      pagination: {
        el: "#product_main_media_list .swiper-pagination",
        clickable: true,
      },
      thumbs: {
        swiper: product_main_thumb,
      },
      breakpoints: {
        990: {
          spaceBetween: 10,
        },
      },
    });

    // Add event listener to update main Swiper slide when variant is clicked
    $('[name="product-variant"]').on("change", function () {
      var selectedVariantId = $(this).val(); // Get selected variant's ID
      var featuredMediaId = $(
        '.product_main_media_list .swiper-slide[data-option-value-id="' +
          selectedVariantId +
          '"]'
      ).attr("data-option-value-id");

      // Find the corresponding slide and activate it
      if (featuredMediaId) {
        var activeSlide = $(
          '.product_main_media_list .swiper-slide[data-option-value-id="' +
            featuredMediaId +
            '"]'
        );
        if (activeSlide.length) {
          product_main_image.slideTo(activeSlide.index());
        }
      }
    });
  }

  // __________  Product main Gallary

  // __________  Recently View Prouct
  if ($(".recently-view-product").length > 0) {
    let recentlyViewed =
      JSON.parse(localStorage.getItem("recentlyViewed")) || [];
    var recentlyViewed_length = recentlyViewed.length;
    var current_view_product = $("body").hasClass("template--product")
      ? $(".section-main-product").data("url")
      : "";
    if (recentlyViewed.length > 0 && recentlyViewed[0] != "") {
      var count = 0;
      $(recentlyViewed).each(function (i, item) {
        count++;
        if (current_view_product != item) {
          fetch(`${item}?view=card`)
            .then((responseText) => responseText.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(
                responseText,
                "text/html"
              );
              $(".recently-view-product .recently-view-product-row").append(
                $(html).find(".card-product-block-wrap")
              );
              if (recentlyViewed_length == count) {
                $(".recently-view-product").removeClass("hidden");
                var recently_view_product = new Swiper(
                  ".recently-view-product .recently-view-product-slider",
                  {
                    slidesPerView: 2,
                    spaceBetween: 5,
                    mousewheel: {
                      forceToAxis: true,
                    },
                    navigation: {
                      nextEl:
                        ".recently-view-product-slider-wrap .swiper-button-next",
                      prevEl:
                        ".recently-view-product-slider-wrap .swiper-button-prev",
                    },
                    breakpoints: {
                      990: {
                        slidesPerView: 5,
                        spaceBetween: 5,
                        centeredSlides: false,
                      },
                      750: {
                        slidesPerView: 3,
                        spaceBetween: 5,
                        centeredSlides: false,
                      },
                    },
                  }
                );
              }
            });
        }
      });
    }
  }
  // __________  Recently View Prouct

  // __________ WISHLIST

  var wishlist_storage = JSON.parse(localStorage.getItem("wishlist"));
  if (wishlist_storage === null) {
    wishlist_storage = [];
    localStorage.setItem("wishlist", JSON.stringify(wishlist_storage));
  }

  var get_wish_list = JSON.parse(localStorage.getItem("wishlist"));
  console.log("get_wish_list", get_wish_list);
  header_wishlist_update(get_wish_list.length);

  function header_wishlist_update(count) {
    $(".header .header__icon--wishlist .wishlist-count-bubble").text(count);
  }

  function wishlist_icon() {
    var wishlist_i = JSON.parse(localStorage.getItem("wishlist"));
    for (var i = 0; i < wishlist_i.length; i++) {
      $(".wishlist-btn").each(function (k) {
        if ($(this).data("handle") == wishlist_i[i]) {
          $(this).addClass("active");
        }
      });
    }
  }
  wishlist_icon();

  $(document).on("click", ".wishlist-btn", function (e) {
    e.preventDefault();
    $(this).toggleClass("active");
    var data = $(this).data("handle");
    var storage = JSON.parse(localStorage.getItem("wishlist"));
    storage.indexOf(data) === -1
      ? storage.push(data)
      : storage.splice(storage.indexOf(data), 1);
    localStorage.setItem("wishlist", JSON.stringify(storage));

    var get_for_count = JSON.parse(localStorage.getItem("wishlist"));
    header_wishlist_update(get_for_count.length);
    if ($(this).parents(".wishlist_product-grid").length) {
      $(this).parents(".card-product-block-wrap").remove();
      if (get_wish_list.length == 0) {
        $(".main-wishlist").addClass("empty-wishlist");
      } else {
        $(".main-wishlist").removeClass("empty-wishlist");
      }
    }
  });

  if ($(".main-wishlist").length) {
    var wishlist__count = 0;
    $(get_wish_list).each(function (i, item) {
      count++;
      fetch(`/products/${item}?view=card`)
        .then((responseText) => responseText.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          $(".main-wishlist .wishlist_product-grid").append(
            $(html).find(".card-product-block-wrap")
          );
          wishlist_icon();
        });
    });
    if (get_wish_list.length == 0) {
      $(".main-wishlist").addClass("empty-wishlist");
    } else {
      $(".main-wishlist").removeClass("empty-wishlist");
    }
  }

  // __________ WISHLIST

  // __________ Custom Size Properties
  if ($("#custom-size_option").length > 0) {
    $(document).on("click", "#custom-size-clear", function (e) {
      e.preventDefault();
      $(this)
        .parents("#custom-size_option")
        .find(".field_input")
        .val("")
        .trigger("input");
    });

    $(document).on(
      "change",
      '#custom-size_option input[type="radio"]',
      function () {
        var name = $(this).attr("name");
        var value = $('input[name="' + name + '"]:checked').val();
        $('#custom-size-form-val input[name="' + name + '"]').val(value);
      }
    );

    $(document).on(
      "input",
      '#custom-size_option input[type="text"]',
      function () {
        var name = $(this).attr("name");
        var value = $(this).val();
        $('#custom-size-form-val input[name="' + name + '"]').val(value);
      }
    );
  }
  // __________ Custom Size Properties

  // __________ Sort Popup
  if ($(".sort_by-popup").length > 0) {
    $(document).on("click", ".sort_by-popup .sort_by-popup-btn", function (e) {
      e.preventDefault();
      $(this).closest(".sort_by-popup").toggleClass("open_popup");
    });

    $("body").on("click", function (event) {
      if (!$(event.target).closest(".sort_by-popup").length) {
        $(".sort_by-popup").removeClass("open_popup");
      }
    });
  }
  // __________ Sort Popup

  if ($("#FacetFiltersFormMobile").length > 0) {
    $(document).on(
      "click",
      ".mobile-facets__details .mobile-facets__summary",
      function (e) {
        e.preventDefault();
        $(this)
          .next(".mobile-facets__submenu")
          .slideToggle()
          .parents(".mobile-facets__details")
          .toggleClass("active");
        $(this)
          .parents(".mobile-facets__details")
          .siblings(".mobile-facets__details")
          .removeClass("active")
          .find(".mobile-facets__submenu")
          .slideUp();
      }
    );
  }

  // __________ cart drawer
  $(document).on("click", "#cart-drawer-note-toggle", function (e) {
    $(this).toggleClass("active");
    $("#cart-drawer-note").toggleClass("active");
  });

  $(document).on("click", "#cart-note-close", function (e) {
    $("#cart-drawer-note-toggle").removeClass("active");
    $("#cart-drawer-note").removeClass("active");
  });
  // __________ cart drawer

  // __________ Footer-Toggle
  $(document).ready(function () {
    if (window.matchMedia("(max-width: 749px)").matches) {
      $(".footer-block__heading").on("click", function () {
        $(this).next(".footer-block__details-content").slideToggle("slow");
        $(this)
          .closest(".footer-block.footer-block--menu")
          .toggleClass("active")
          .siblings(".footer-block.footer-block--menu")
          .removeClass("active")
          .find(".footer-block__details-content")
          .slideUp("slow");
      });
    }
  });
  // __________ Footer-Toggle
});

/* ========================== */
document.addEventListener("DOMContentLoaded", function () {
  const mediaList = document.querySelector(
    ".slider-mobile-gutter .product__media-list"
  );
  const thumbnailSlider = document.querySelector(
    ".product--thumbnail_slider .thumbnail-slider"
  );

  if (mediaList && thumbnailSlider) {
    const updateHeight = () => {
      thumbnailSlider.style.height = `${mediaList.offsetHeight}px`;
    };
    // Set initial height
    updateHeight();
    // Adjust height on window resize
    window.addEventListener("resize", updateHeight);
  }
});

//____________
document
  .querySelectorAll("#Slider-Thumbnails-template--18581268725990__main li")
  .forEach((item) => {
    item.addEventListener("click", () => {
      const img = item.querySelector("img");
      if (img) {
        const productMedia = document.querySelector(
          ".product__media.media.media--transparent"
        );
        if (productMedia) {
          productMedia.innerHTML = "";
          const newImg = document.createElement("img");
          newImg.src = img.src;
          newImg.alt = img.alt;
          newImg.width = img.width;
          newImg.height = img.height;
          productMedia.appendChild(newImg);
        }
      }
    });
  });

$(window).on("load", function () {
  $(".sw--product").each(function () {
    var productContainer = $(this),
      firstCheckedInput = productContainer
        .find('.sw--form-input input[type="radio"]:checked')
        .last(),
      colorAttr = firstCheckedInput
        .closest(".sw--form-input")
        .find(".swatch-input__label .color-swatch")
        .attr("data-color-alt"),
      allImages = productContainer.find(".thumbnail img"),
      matchedImage = allImages.filter('[alt="' + colorAttr + '"]'),
      allImagesList = productContainer.find(
        ".product__media-item.grid__item img"
      ),
      matchedImageList = allImagesList.filter('[alt="' + colorAttr + '"]');

    console.log("firstCheckedInput:::", firstCheckedInput);

    if (matchedImage.length) {
      allImages.parents(".thumbnail-list__item").hide();
      matchedImage.parents(".thumbnail-list__item").show();

      allImagesList.parents(".product__media-item").hide();
      matchedImageList.parents(".product__media-item").show();
    }
  });
});

$(document).on("click", ".swatch-input__label", function () {
  var ele = $(this),
    productContainer = ele.parents(".sw--product"),
    colorAttr = ele.find(".color-swatch").attr("data-color-alt"),
    allImages = productContainer.find(".thumbnail img"),
    matchedImage = allImages.filter('[alt="' + colorAttr + '"]'),
    allImagesList = productContainer.find(
      ".product__media-item.grid__item img"
    ),
    matchedImageList = allImagesList.filter('[alt="' + colorAttr + '"]');

  if (matchedImage.length) {
    allImages.parents(".thumbnail-list__item").hide();
    matchedImage.parents(".thumbnail-list__item").show();

    allImagesList.parents(".product__media-item").hide();
    matchedImageList.parents(".product__media-item").show();
  }
  
});
